<template>
    <div class="box">
        <div v-if="isAuth" class="appStatusBar appStatusBar--manager"
            :class="{ 'appStatusBar--error': appStatus.isError }">
            <div class="appStatusBar__left">WIDOK ADMINISTRATORA</div>
            <div class="appStatusBar__left--expand" @click="guestMode">Przełącz na: WIDOK GOŚCIA</div>
            <div style="flex: 1 1 auto">{{ appStatus.message }}</div>
            <div class="appStatusBar__right">NIE UDOSTĘPNAIJ TEGO WIDOKU</div>
        </div>
        <div v-else class="appStatusBar" :class="{ 'appStatusBar--error': appStatus.isError }">{{
            appStatus.message }}</div>
        <!-- Loading. -->
        <img class="logo-loader" v-if="isLoading || !ready" src="@/assets/images/logo-active-progress.png" alt />
        <div class="lds-roller" v-if="!ready || isLoading">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <transition name="fade">
            <div class="dark-wall" v-if="isLoading" />
        </transition>
        <transition name="fade">
            <ManagerMenu v-if="isManager" :isManager.sync="isManager" :classifications="competitionClassifications" />
        </transition>
        <div class="home" v-if="ready" :class="{ par0i: isMenu }">
            <div class="home-map col-12" :class="[isMenu ? 'col-md-8 col-lg-9' : 'col-md-12']">
                <!-- Map. -->
                <base-map @ready="; (map = $event), $connect()" @gpx:ready="gpxReady = true"
                    :classifications="competitionClassifications" class="map" ref="map">
                    <!-- Special Device markers 
                    :connectTo="[
                        positions[62].latitude,
                        positions[62].longitude,
                    ]" 
                    -->
                    <SpecialMapMarker v-for="player in listPlayers.filter(a => a.specialName)" :key="player.id"
                        :latLng="devicePosition(player.deviceId)" :device="player._device()" :visible="true"
                        :connectTo="devicePosition()">
                        <template #icon>
                            <!-- players[id].deviceId -->
                            <SpecialIconOval :deviceId="player.deviceId" :iconActive="true" />
                        </template>
                        <template #popup>
                            {{
                                player.specialName
                                    ? player.specialName
                                    : `${player.firstname} ${player.lastname}`
                            }}
                        </template>
                    </SpecialMapMarker>
                    <!-- Track markers. -->
                    <base-map-marker v-for="player in listPlayers.filter(a => !a.specialName)" :key="player.id"
                        @ready="onReadyMarker($event, player)" :device="player._device()"
                        :latLng="devicePosition(player.deviceId)" :devicePosition="positions[player.deviceId]"
                        :deviceColor="player.deviceColor" :visible="player.isVisible && player.isLocatedInTrackZone
                            ">
                        <template #icon>
                            <!-- players[id].deviceId -->
                            <div v-if="player.playerNumber" class="player-number">
                                {{ player.playerNumber }}
                            </div>
                            <IconOval :deviceId="player.deviceId" :deviceColor="player.deviceColor"
                                :iconActive="hasSelectedClassification(player)" />
                        </template>
                        <template #popup>
                            {{
                                player.id
                                    ? `${player.firstname} ${player.lastname}`
                                    : player.specialName
                            }}
                        </template>
                    </base-map-marker>
                    <!-- Points.  -->
                    <map-point v-for="point in points" :key="point.id" :classifications="competitionClassifications"
                        :point="point" />
                </base-map>
                <!-- Organizer/operator logo. -->
                <div class="home-map__logo" :class="{ 'home-map__logo--manager': isManager }">
                    <img :src="logoLink" alt="Logo" />
                </div>
                <transition name="slide">
                    <!-- Menu icon. -->
                    <div class="home-map__menu-btn" @click="isMenu = !isMenu">
                        <i class="fas fa-address-book fa-flip-horizontal" />
                        <i class="fa fa-share fa-flip-vertical" :class="isMenu ? '' : 'fa-flip-horizontal'" />
                        <i :class="isMenu ? 'fas fa-times' : 'fas fa-info-circle'" />
                        <div class="adminFrame" v-show="isAuth" @click.stop="isManager = !isManager">
                            <i :class="'fas fa-stopwatch'" />
                            <i :class="'fas fa-flag-checkered'" />
                        </div>

                    </div>
                </transition>
                <template v-if="isPlaybackReady">
                    <base-controls :playback="$options.playback" />
                </template>
            </div>
            <transition name="slide">
                <!-- Devices menu. -->
                <base-devices-menu v-if="map" class="home-map__menu col-12 col-md-4 col-lg-3" :isMenu.sync="isMenu"
                    :classifications="competitionClassifications" :players="listPlayers.filter(a => !a.specialName)"
                    v-show="isMenu" />
            </transition>
        </div>
    </div>
</template>

<script>
import BaseDevicesMenu from '@/components/BaseDevicesMenu'
import BaseMap from '@/components/BaseMap'
import BaseMapMarker from '@/components/BaseMapMarker'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_MARKER, SET_PLAYBACK_MARKERS } from '@/store/mutations.type'
import { TRACKPOINT_TYPES } from '@/config'
import { createPoints } from '@/service/map'
import { BOOTSTRAP_MAP } from '@/store/actions.type'
import { SET_SELECTED_CLASSIFICATION_ID } from '@/store/mutations.type'
import MapPoint from '@/components/MapPoint'
import _ from 'lodash'
import {
    SET_ENTITIES,
    SET_APP_STATUS,
    CLEAR_ENTITIES,
    SET_IS_PLAYBACK_READY,
    SET_FOCUS_DEVICE_ID,
} from '@/store/mutations.type'
import schema from '@/api/schema'
import { normalize } from 'normalizr'
import BaseControls from '@/components/BaseControls'
import IconOval from '@/components/IconOval'
import { initPlayback } from '@/service/playback'
import moment from 'moment'
import { setBoundsFromLatLng } from '@/utils/distanceMarkers'
import SpecialMapMarker from '@/components/SpecialMapMarker.vue'
import SpecialIconOval from '@/components/SpecialIconOval.vue'
import { apiDostartu } from '@/api'
import ManagerMenu from '@/components/ManagerMenu.vue'
// import { apiDostartu } from '@/api'
export default {
    components: {
        BaseDevicesMenu,
        BaseMap,
        BaseMapMarker,
        SpecialMapMarker,
        SpecialIconOval,
        MapPoint,
        BaseControls,
        IconOval,
        ManagerMenu,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isMenu: true,
            types: TRACKPOINT_TYPES,
            ready: false,
            map: {},
            prevSelectedClassificationId: null,
            gpxReady: false,
            isPlay: false,
            playback: null,
            isLoading: false,
            isResults: false,
            apiKey: null,
            isManager: null,
            isAuth: false
        }
    },
    computed: {
        ...mapGetters([
            'appStatus',
            'devices',
            'awardedDeviceIds',
            'isHighlightedDevicesView',
            'focusDeviceId',
            'trackpointsBy',
            'classifications',
            'selectedClassificationId',
            'markers',
            'players',
            'tracksBounds',
            'positions',
            'isLiveMode',
            'isPlaybackReady',
            'competitions',
            'playbackMarkers',
            'competitionLayouts',
            'isShowAllNames',
            'eventTimesData',
        ]),
        listPlayers() {
            // isVisible defines when to show the player
            let players = Object.values(this.players)
            const playersWithDevice = players.filter(player => player.deviceId)
            for (let player of playersWithDevice) {
                player.isLocatedInTrackZone = this.isLocatedInTrackBoundsZone(
                    player
                )
                if (this.isHighlightedDevicesView) {
                    player.isVisible =
                        this.awardedDeviceIds.includes(player.deviceId)
                } else {
                    player.isVisible =
                        this.hasSelectedClassification(player) ||
                        this.isSpecial(player)
                }
            }
            return playersWithDevice
        },
        logoLink() {
            return this.competitionLayouts[
                this.competition.id
            ].logoLink.replace('zawodybiegowe', 'dostartu')
        },
        focusedDevicePosition() {
            return this.devices[this.focusDeviceId]?._position()
        },
        competition() {
            return this.competitions[this.id]
        },
        competitionClassifications() {
            return this.competition._classifications()
        },
        trackpoints() {
            return this.trackpointsBy(this.competitionClassifications)
        },
        points() {
            return createPoints(this.trackpoints)
        },
    },
    async created() {
        //Checking authorisation
        this.checkIsManager()
        // Bootstrap map.
        await this.BOOTSTRAP_MAP(this.id)
        // Adding websocket listener.
        this.$options.sockets.onmessage = ({ data }) => {
            let parseData = JSON.parse(data)
            if (parseData.positions) {
                // Update positions entity.
                const normalized = normalize(parseData.positions, [
                    schema.position,
                ])
                this.SET_APP_STATUS({
                    isError: false,
                    message: 'Połączono z serwerem. Aktualizacja automatyczna.',
                })
                this.SET_ENTITIES(normalized.entities)
            }
        }
        if (window.innerWidth < 768) {
            this.isMenu = false
        }
        // if (!this.appStatus.isError) {
        this.ready = true
        // }
    },

    methods: {
        ...mapMutations([
            SET_APP_STATUS,
            SET_SELECTED_CLASSIFICATION_ID,
            SET_MARKER,
            SET_ENTITIES,
            CLEAR_ENTITIES,
            SET_IS_PLAYBACK_READY,
            SET_PLAYBACK_MARKERS,
            SET_FOCUS_DEVICE_ID,
        ]),
        ...mapActions([BOOTSTRAP_MAP]),
        guestMode() {
            this.isAuth = false
        },
        devicePosition(deviceId) {
            if (deviceId) {
                if (this.positions[deviceId]) {
                    return [
                        this.positions[deviceId].latitude,
                        this.positions[deviceId].longitude,
                    ]
                } else return [0, 0]
            } else return null
        },
        async checkIsManager() {
            let key = this.$route.query.key;
            if (key) {
                this.apiKey = key;
                sessionStorage.setItem('apiKey', key);
                const { query, path } = this.$route;
                const newQuery = { ...query };
                delete newQuery.key;
                this.$router.replace({ path, query: newQuery });
            } else {
                key = sessionStorage.getItem('apiKey');
                if (key) {
                    this.apiKey = key;
                }
            }
            if (this.apiKey) {
                await apiDostartu.post(`/competitions/${this.id}/auth`, { api_key: this.apiKey })
                    .then(response => this.isAuth = response.authorized)
            }
        },
        hasSelectedClassification(player) {
            return player.classification === this.selectedClassificationId
        },
        isSpecial(player) {
            return Boolean(player.specialName)
        },
        isLocatedInTrackBoundsZone(player) {
            if (
                !this.isPlaybackReady &&
                this.gpxReady &&
                this.positions[player.deviceId]
            ) {
                if (this.tracksBounds[player.classification]) {
                    return this.tracksBounds[
                        player.classification
                    ].contains([
                        this.positions[player.deviceId].latitude,
                        this.positions[player.deviceId].longitude,
                    ])
                } else {
                    // If there is no track bounds for classification, use area of 10 km around competition location.
                    return setBoundsFromLatLng({ lat: this.competition.locationLat, lng: this.competition.locationLng }, 20).contains([
                        this.positions[player.deviceId].latitude,
                        this.positions[player.deviceId].longitude,
                    ])
                }
            }
            if (this.isPlaybackReady && this.playbackMarkers[player.deviceId]) {
                return this.tracksBounds[
                    this.selectedClassificationId
                ].contains(this.playbackMarkers[player.deviceId].getLatLng())
            }
            return false
        },
        getEndTime() {
            let startTime
            let currentClassification = this.classifications[
                this.selectedClassificationId
            ]
            let endTime = currentClassification.endTime || this.eventTimesData.end_event ? moment(this.eventTimesData.end_event) : moment()
            if (currentClassification.startTime) {
                startTime = currentClassification.startTime.clone()
            } else {
                startTime = this.competition.startedTime.clone()
            }
            // when the classification ended
            if (endTime) {
                return endTime.clone()
            } else if (!endTime && moment().diff(startTime) > 1209600000) {
                // 1 209 600 000ms = 14 days.

                return startTime.add(1209600000, 'ms')
            } else {
                return moment()
            }
        },
        // Setup marker's handlers (Live mode)
        onReadyMarker(marker, player) {
            marker.deviceId = player.deviceId
            marker.trackNumber = player.trackNumber
            if (player.classification) {
                marker.on('mouseover', event => {
                    event.target.openPopup()
                    if (
                        player.classification !== this.selectedClassificationId
                    ) {
                        this.prevSelectedClassificationId = this.selectedClassificationId
                        this.SET_SELECTED_CLASSIFICATION_ID(
                            player.classification
                        )
                    }
                })
                // Change classification on marker click.
                marker.on('click', () => {
                    if (player.classification) {
                        this.SET_SELECTED_CLASSIFICATION_ID(
                            player.classification
                        )
                        this.prevSelectedClassificationId = null
                    }
                })
                marker.on('mouseout', event => {
                    if (
                        event.target.deviceId !== this.focusDeviceId &&
                        !this.isShowAllNames
                    ) {
                        event.target.closePopup()
                    }
                    if (this.prevSelectedClassificationId) {
                        this.SET_SELECTED_CLASSIFICATION_ID(
                            this.prevSelectedClassificationId
                        )
                        this.prevSelectedClassificationId = null
                    }
                })
                marker.on('popupclose', event => {
                    if (this.isShowAllNames) {
                        setTimeout(() => event.target.openPopup(), 1000)
                    }
                })
            }
            this.SET_MARKER(marker)
        },
        setCenterOnMap(devicePosition) {
            if (devicePosition) {
                this.map.setView(
                    [devicePosition.latitude, devicePosition.longitude],
                    17
                )
            } else {
                // Fit to track if unfocused device.
                let bounds
                this.map.eachLayer(layer => {
                    if (
                        layer._gpx &&
                        layer.classification === this.selectedClassificationId
                    ) {
                        bounds = layer.getBounds()
                    }
                })
                this.map.fitBounds(bounds)
            }
        },
        setPopup(devicePosition, oldDevicePosition) {
            let deviceId = devicePosition?.deviceId
            let oldDeviceId = oldDevicePosition?.deviceId
            let marker
            let oldMarker
            if (deviceId) {
                // Live mode
                if (this.isLiveMode) {
                    marker = _.find(
                        this.markers,
                        marker => marker.deviceId === deviceId
                    )
                } else {
                    // Playback mode
                    marker = _.find(
                        this.playbackMarkers,
                        marker => marker.feature.properties.device === deviceId
                    )
                }

                marker.off('mouseout')
                marker.openPopup()
                marker.openTooltip()
            }
            // Set on 'mouseout' in old focusedDevice.
            if (oldDeviceId && oldDeviceId !== deviceId) {
                // Live mode
                if (this.isLiveMode) {
                    oldMarker = _.find(
                        this.markers,
                        marker => marker.deviceId === oldDeviceId
                    )
                } else {
                    // Playback mode
                    oldMarker = _.find(
                        this.playbackMarkers,
                        marker =>
                            marker.feature.properties.device === oldDeviceId
                    )
                }
                if (oldMarker) {
                    oldMarker.closePopup()
                    oldMarker.closeTooltip()
                    oldMarker.on('mouseout', event => {
                        if (oldDeviceId !== this.focusDeviceId) {
                            event.target.closePopup()
                            event.target.closeTooltip()
                        }
                    })
                }
            }
        },
    },
    watch: {
        // FocusedDevice changed on focusedDevicePosition (socket doesnt listen "devices" messages(useless) so need watching devices's positions)
        //@TODO Check for playback mode, live mode working :)
        focusedDevicePosition: {
            deep: true,
            handler(devicePosition, oldDevicePosition) {
                if (this.map._loaded) {
                    if (!this.isPlaybackReady) {
                        this.setCenterOnMap(devicePosition)
                    }
                    this.setPopup(devicePosition, oldDevicePosition)
                }
            },
        },
        isMenu() {
            // Timeout for waiting on menu transition.
            setTimeout(() => this.map.invalidateSize(true), 1000)
        },
        isLiveMode() {
            if (this.focusDeviceId) {
                this.SET_FOCUS_DEVICE_ID(null)
            }
            this.isLoading = true
            // Timeout for transition

            if (this.isLiveMode && this.isPlaybackReady) {
                this.$connect()
                setTimeout(() => {
                    this.$options.playback.clearData()
                    this.SET_IS_PLAYBACK_READY(false)
                    this.SET_PLAYBACK_MARKERS(null)
                    this.isLoading = false
                }, 400)
            }

            if (!this.isLiveMode) {
                this.$disconnect()
                this.SET_APP_STATUS({
                    isError: false,
                    message: 'Rozłączono. Przeglądasz zapis archiwalny.',
                })
                // Timeout for transition
                setTimeout(async () => {
                    let fromTime = this.competition.startedTime.clone()
                    fromTime = fromTime.toISOString()

                    let endTime = this.getEndTime()
                    let toTime = endTime.toISOString()
                    // console.log('InitPlayback ', fromTime, toTime);
                    let { playback, markers } = await initPlayback(
                        this.map,
                        fromTime,
                        toTime
                    )
                    this.$options.playback = playback
                    this.SET_PLAYBACK_MARKERS(markers)
                    this.SET_IS_PLAYBACK_READY(true)
                    this.isLoading = false
                }, 400)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.appStatusBar {
    position: relative;
    // top: 0;
    // left: 0;
    // right: 0;
    z-index: 9999999;
    text-align: center;
    font-size: 12px;
    color: $white;
    background-color: $charcoal-grey;
    padding: 4px;

    &--error {
        font-size: 16px;
        background-color: $red-orange;
    }

    &--manager {
        display: flex;
        justify-content: space-between;
    }

    &__left,
    &__right {
        padding: 0 10px;
        background-color: $managerColor;

        &--expand {
            // justify-self: flex-start;
            padding: 0 10px;
            cursor: pointer;
            background-color: $slate-two;
        }
    }
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

.slide-enter-active {
    transition: all 0.4s ease;
}

.slide-leave-active {
    transition: all 0.4s ease;
}

@media (min-width: 768px) {
    .slide-enter-active {
        transition: all 0.8s ease;
    }

    .slide-leave-active {
        transition: all 0.4s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }
}

.map {
    height: 100%;
    width: 100%;
}

.home {
    display: flex;
    overflow: hidden;
    height: 100%;

    &-map {
        height: 100%;
        position: relative;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: $white;
        padding-left: 0;
        transition: all 0.8s;
        padding-right: 0;

        @media (max-width: 767px) {
            &--hide-mobile {
                display: none;
            }

            &__menu {
                position: absolute;
                z-index: 9999;
                background-color: $white;
            }
        }

        &__logo {
            position: absolute;
            z-index: 9999;
            top: 24px;
            left: 24px;
            height: 80px;
            width: 80px;
            max-height: 80px;
            max-width: 80px;
            border-radius: 4px;
            overflow: hidden;
            background-color: $white;
            padding: 4px;
            display: flex;

            &--manager {
                box-shadow: inset 0 0 0 4px $managerColor;
            }

            // cursor: none;
            & img {
                width: 100%;
                object-fit: contain;
            }
        }

        @media (min-width: 768px) {
            &__logo {
                height: 128px;
                width: 128px;
                max-height: 128px;
                max-width: 128px;
                padding: 8px;
            }
        }

        &__menu-btn {
            position: absolute;
            top: 8px;
            right: 0px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            z-index: 9999;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            width: 40px;
            font-size: 28px;
            background-color: $white;
            cursor: pointer;
            overflow: hidden;

            div {
                background-color: $pale-grey;
            }

            .adminFrame {
                box-shadow: inset 0 0 0 3px $managerColor;
            }

            i {
                margin: 5px;
                transition: transform 1s;
            }
        }
    }

    @media (min-width: 768px) {
        padding: 16px;
        padding-top: 0;
    }
}

.box {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.logo-loader {
    width: 140px;
    position: absolute;
    left: calc(50% - 70px);
    top: calc(45% - 70px);
    z-index: 999999;
}

// Loading map animation.
.lds-roller {
    display: inline-block;
    min-width: 80px;
    min-height: 80px;
    margin: auto;
    position: absolute;
    z-index: 999999;
    top: calc(50% - 40px);
    left: calc(50% - 40px);

    div {
        animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        transform-origin: 40px 40px;

        &:after {
            content: ' ';
            display: block;
            position: absolute;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: $charcoal-grey;
            margin: -4px 0 0 -4px;
        }

        &:nth-child(1) {
            animation-delay: -0.036s;

            &:after {
                top: 63px;
                left: 63px;
            }
        }

        &:nth-child(2) {
            animation-delay: -0.072s;

            &:after {
                top: 68px;
                left: 56px;
            }
        }

        &:nth-child(3) {
            animation-delay: -0.108s;

            &:after {
                top: 71px;
                left: 48px;
            }
        }

        &:nth-child(4) {
            animation-delay: -0.144s;

            &:after {
                top: 72px;
                left: 40px;
            }
        }

        &:nth-child(5) {
            animation-delay: -0.18s;

            &:after {
                top: 71px;
                left: 32px;
            }
        }

        &:nth-child(6) {
            animation-delay: -0.216s;

            &:after {
                top: 68px;
                left: 24px;
            }
        }

        &:nth-child(7) {
            animation-delay: -0.252s;

            &:after {
                top: 63px;
                left: 17px;
            }
        }

        &:nth-child(8) {
            animation-delay: -0.288s;

            &:after {
                top: 56px;
                left: 12px;
            }
        }
    }
}

.dark-wall {
    background-color: $charcoal-grey;
    opacity: 0.3;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 99999;
}

// .results-wall {
//     border: 1px solid black;
//     // background-color: $light-grey;
//     // background-color: $pale-grey;
//     background-color: #a0b1b9;
//     opacity: 1;
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     right: 0;
//     z-index: 99999;
//     margin: 8px;

// }

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

@keyframes lds-roller {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.player-number {
    position: absolute;
    transform: translate(-45%, -80%);
    font-size: 18px;
    left: 50%;
    top: 0;
    padding: 6px;
    text-shadow: 2px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff,
        1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;
    width: 40px;
    height: 40px;
    font-weight: bold;
}
</style>
